import { updateUserConfigurationAndService } from 'owa-session-store/lib/utils/updateUserConfigurationAndService';
import {
    UpdateUserConfigurationEntry,
    UserOptionsUpdateConfigName,
} from 'owa-service/lib/types/UpdateUserConfigurationEntry';
import { setIsLeftNavShown } from '../mutators/leftNavStateMutators';

export const VIEW_STATE_CONFIGURATION: UserOptionsUpdateConfigName = 'OWA.ViewStateConfiguration';

export function updateCalendarSidePanelState(
    calendarSidePanelViewState: boolean,
    calendarSidePanelWidth?: number
): Promise<any> {
    setIsLeftNavShown(calendarSidePanelViewState);
    const updates: UpdateUserConfigurationEntry<'OWA.ViewStateConfiguration'>[] = [];
    if (typeof calendarSidePanelWidth == 'number') {
        updates.push({
            key: 'CalendarSidePanelWidth',
            valuetype: 'Integer32',
            value: [`${calendarSidePanelWidth}`],
        });
    }
    return updateUserConfigurationAndService(
        config => {
            // Update the local user configuration store
            if (typeof calendarSidePanelWidth == 'number') {
                config.ViewStateConfiguration.CalendarSidePanelWidth = calendarSidePanelWidth;
            }
        },
        updates,
        VIEW_STATE_CONFIGURATION
    );
}
